import styled from "styled-components";
import Button from '@mui/material/Button';
import axios from 'axios'
import { useState } from 'react'
import { useDispatch } from 'react-redux'


const Container=styled.div`

`;


export default function DeleteButton(props){
	let { iDlte,url,action,selected } = props;
	let [disabled,setDisabled]=useState(false);
	let dispatch=useDispatch();
	let handleClick=async()=>{
		if(window.confirm("desea eliminar este registro")){
			setDisabled(true);
			try{
				let rsp=await axios.delete(`${url}/?id=${iDlte}`,{ withCredentials: true } );
				console.log(rsp);
				alert(`registro con id  "${rsp.data.id}"  fue eliminado `);
				dispatch(action(0));
				dispatch(selected);
			}catch(err){console.log(err);alert(`error al guardar ${err.response.data}`)}
			setDisabled(false);			
		}
	}

	return(
	<Container>
		<Button variant="contained" disabled={disabled} onClick={handleClick}>delete</Button>
	</Container>

	)
}